import React from "react";
import errorpage from "../assets/errorpage.svg";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <div style={{ paddingTop: "5rem" }} className="errorpage">
      <div className="d-flex justify-content-center mt-4">
        <img
          src={errorpage}
          style
          alt="404 error"
          style={{ width: "50%", height: "auto" }}
        />
      </div>
      <h3 className="text-center">Page not found</h3>
      <p className="text-center">
        The link you clicked may be broken or the page may have been removed or
        renamed.
      </p>
      <div className="d-flex justify-content-center mt-4">
        <Link className="button" to="/">
          Go back
        </Link>
      </div>
    </div>
  );
};

export default ErrorPage;
